if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          const shopTheLookModal = this.closest('modal-dialog');
          if (quickAddModal || shopTheLookModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            if (quickAddModal) {
              quickAddModal.hide(true);
            } else {
              shopTheLookModal.hide(true);
            }
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/*
 * Sticky ATB fix - GB 10/26
 * Bottom-aware sticky buy box for the stacked desktop PDP layout.
 * The info column is sticky (top: 20px) but taller than short laptop windows,
 * which pinned Add to bag below the fold while the gallery scrolled.
 * This sets the column's sticky top so it pins once Add to bag is fully on screen:
 *   top = min(20px, 100vh - <distance from column top to button bottom> - 16px)
 * Tall windows keep the original 20px. Below 990px nothing changes.
 * To revert: delete this block.
 */
(() => {
  if (window.__bdStickyBuybox) return;
  window.__bdStickyBuybox = true;

  const SELECTOR = 'section[id^="MainProduct-"] .product--stacked .product__info-wrapper';
  const GAP = 16;
  const mq = window.matchMedia('(min-width: 990px)');

  const init = () => {
    document.querySelectorAll(SELECTOR).forEach((col) => {
      if (col.dataset.stickyBuybox) return;
      col.dataset.stickyBuybox = 'true';

      const update = () => {
        const atb = col.querySelector('.product-form__submit');
        if (!mq.matches || !atb || !atb.offsetParent) {
          col.style.removeProperty('top');
          return;
        }
        const offset = Math.ceil(atb.getBoundingClientRect().bottom - col.getBoundingClientRect().top);
        col.style.top = `min(20px, calc(100vh - ${offset}px - ${GAP}px))`;
      };

      if ('ResizeObserver' in window) new ResizeObserver(update).observe(col);
      mq.addEventListener ? mq.addEventListener('change', update) : mq.addListener(update);
      window.addEventListener('load', update, { once: true });
      update();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
